import * as Yup from "yup"

export const SDEquipmentTypeInitialValues = {
	description: "",
	allocateToEmployee: false,
	allocateToSite: false,
}

export const SDEquipmentTypeSchema = Yup.object().shape({
	description: Yup.string().required().label("Description").trim(),
	allocateToEmployee: Yup.boolean().required().label("Allocate to Employee"),
	allocateToSite: Yup.boolean().required().label("Allocate to Site"),
})
